<template>
  <div class="header"  v-if='currentUser'>

    <a href="#" class="hamburger"><i class="fas fa-bars"></i></a>
    <!-- <a href="#" class="btn-link toggle-sidebar d-lg-none pg-icon btn-icon-link" data-toggle="sidebar">
      menu</a> -->
    <div class="in_mobile">
      <a href="#" class="toggle-secondary-sidebar" v-if='actionName && actionName.lable_name'>
        <span class="d-flex align-items-center">
          {{actionName.lable_name}} <span class="text-info" v-if="actionNumber[actionName.count_key]"> &nbsp;({{actionNumber[actionName.count_key]}})</span> <span class="pg-icon">drop_down</span>
        </span> 
      </a>
      <div v-if="companylogo" class="brand inline d-none d-lg-block d-xl-block" style="padding-left: 80px;">
        <img :src="companylogo" alt="logo" :data-src="companylogo" width="272px" height="33.43px"  class="logo_c">
        <img :src="companylogo" alt="logo" :data-src="companylogo" width="272px" height="33.43px"  class="logo_w">
      </div>
      <div v-else class="brand inline d-none d-lg-block d-xl-block" style="padding-left: 80px;">
        <img src="/static/emailRemlogos/email_remediator.svg" alt="logo" data-src="/static/emailRemlogos/email_remediator.svg" width="272px" height="33.43px"  class="logo_c">
        <img src="/static/emailRemlogos/email_remediator_white.png" alt="logo" data-src="/static/emailRemlogos/email_remediator_white.png" width="272px" height="33.43px"   class="logo_w">
      </div>
    </div>
    <div class="d-flex align-items-center">
      <span v-if='domains.length > 0'>
        <el-select v-model="showDomainSelected"  @change='updateDomain' filterable placeholder="Select Domain">
          <el-option
            v-for="item in domains"
            :key="item.domain.domain"
            :label="item.domain.domain"
            :value="item.domain"
            class="domainname">
          </el-option>
        </el-select>
      </span>
      <span v-if="domain_provider == 5 || domain_provider == 2" class="ml-2 mr-2" :title="officeTokenValidity?'O365 connected':'O365 not connected. Please login using your \'O365\' admin credentials to connect.'"> <i v-if="officeTokenLoader"  class="fas fs-13 fa-sync-alt rotate"></i> <i v-if="officeTokenValidity === true" class="fas fa-circle mr-1 fs-12 text-success"></i> <i v-if="officeTokenValidity === false" class="fas fa-exclamation-circle mr-1 fs-13 text-warning"></i>O365</span>
      <span v-if="domain_provider == 5 || domain_provider == 4" class="ml-2 mr-2" :title="exchangeEwsValidity?'Exchange connected.':'Exchange not connected. Please add/validate your \'Exchange\' credentials to connect.'"> <i v-if="exchangeEwsTokenLoader"  class="fas fs-13 fa-sync-alt rotate"></i> <i v-if="exchangeEwsValidity === true" class="fas fa-circle mr-1 fs-12 text-success"></i> <i v-if="exchangeEwsValidity === false" class="fas fa-exclamation-circle mr-1 fs-13 text-warning"></i>Exchange</span>
      <span class="theme_change  btn-icon-link ml-2" @click="toggleMode()"><i class="fas fa-sun"></i><i class="far fa-moon"></i></span>
      <div class="dropdown pull-right d-lg-block">
        <button class="profile-dropdown-toggle logindetail_p" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="profile dropdown">
          <div class="logindetail" v-if='currentUser && currentUser.displayName'>
            <span>{{currentUser.displayName}}</span>
            <span>{{currentUser.role == 2 ? "(Super Admin)" : "("+capitalize(userAssignedRole)+")"}}</span>
          </div>
          <span class="thumbnail-wrapper d32 circular inline">
            <img v-if='currentUser && currentUser.photoURL && currentUser.photoURL[0]' style="border-radius: 50%" v-bind:src="currentUser.photoURL[0].value" width="32" height="32">
            <img v-else src="/static/img/profiles/user.png" alt="" data-src="/static/img/profiles/user.png" data-src-retina="/static/img/profiles/user.png" width="32" height="32">
          </span>
        </button>
        <div class="dropdown-menu dropdown-menu-right profile-dropdown" role="menu" v-if='currentUser'>
          <span class="dropdown-item custom_dropdown_item">{{ currentUser.primaryEmail }}</span>
          <router-link v-if="domainSelected.domain_provider != 4" tag="li" :to="{ name: 'welcome'}">
          <span class="dropdown-item custom_dropdown_item">Install Extension</span>
          </router-link>
          <router-link :to="{ name: 'profilesettings'}" tag="li">
          <span class="dropdown-item custom_dropdown_item">Settings</span>
          </router-link>
          <router-link v-if ="role ==2" :to="{ name: 'advancedsettings'}" tag="li">
          <span class="dropdown-item custom_dropdown_item">Advanced Settings</span>
          </router-link>
          <router-link  v-if = 'designation != "O365 Admin" &&  designation != "Gsuite Admin" && designation !== "AD SSO"' :to="{ name: 'changepassword'}" tag="li">
            <span class="dropdown-item custom_dropdown_item">Change Password</span>
          </router-link>
          <router-link  v-if = "checkUserPermission('settings_company_setting')" :to="{ name: 'companysettings'}" tag="li">
            <span class="dropdown-item custom_dropdown_item">Company Settings</span>
          </router-link>
          <span class="dropdown-item bg-light text-dark custom_dropdown_item" @click='logOut'>Logout</span>
        </div>
      </div>
    </div>
  </div>
</template>

 <script>
  import { bus } from '../../main';
  import { mapActions, mapGetters } from 'vuex'
  import CcSpinner from '../general/spinner'
  import { version } from '../../config'
  import { http } from 'plugins/http';
  import UTILITY from '../../utils/common.js';
  import { safeParseLocal } from '../../utils/common.js';
  import { baseServerUrl } from '../../config';
  

  export default {
    components: {
      CcSpinner,
    },
    data() {
      return {
        user: {
          company: {
            name: "",
          },
          first_name: '',
        },
        selectedDomain : [],
        role:"",
        userDetails : {},
        domains:[],
        domainSelected:'',
        showDomainSelected:'',
        actionName:'',
        actionNumber:'',
        designation:'',
        userAssignedRole:'', 
        domain_provider:'',
        exchangeEwsValidity:'',
        officeTokenValidity:'',
        officeTokenLoader:false,
        exchangeEwsTokenLoader:false,
        companylogo:'',
        domain:''
  
        
      }
    },
    computed: {
      /**
      * See src/app/auth/vuex/getters.js
      */
      ...mapGetters(['currentUser', 'isLogged']),
      version() {
        return version
      },
    },
    created (){
      this._onChangeActionName = (data) => {
        this.actionName = data;
      }
      this._onChangeActionNumber = (data) => {
        this.actionNumber = data;
      }
      this._onSearchMailProgress = (data) => {
        this.checkProgress(data)
      }
      this._onReloadTokenValidity = () => {
        this.domain_provider = this.$store.state.domain_provider();
          this.checkOfficeTokenValidity()
          this.checkExchangeTokenValidity()
      }
      this._onMimecastMessage = (data) => {
        console.log("LOLOLO")
        this.$toasted.show(data.msg,{
          duration:3000,
          theme: data.type=="error" && "toasted-danger"|| "toasted-primary",
          position: "top-right",
        });
      }
      bus.$on('changeActionName', this._onChangeActionName)
      bus.$on('changeActionNumber', this._onChangeActionNumber)
      bus.$on('searchMailProgress', this._onSearchMailProgress)
      bus.$on('reloadTokenValidity', this._onReloadTokenValidity)
      bus.$on('mimecastMessage', this._onMimecastMessage)
      // bus.$on('checkOfficeTokenValidity', (data) => {
      //   this.checkOfficeTokenValidity(data)
      // })
    },
    beforeMount() { 
       this.userDetails = safeParseLocal('user', null);
       this.role = this.userDetails && this.userDetails.role;
       this.domain_provider = this.$store.state.domain_provider()

       if(this.userDetails) {
          this.getUserRole();
          this.userAssignedRole = this.userDetails.domains && this.userDetails.domains.length && this.userDetails.domains[0].profile || "Admin";
          this.designation = this.userDetails.designation;
          this.selectedDomain = safeParseLocal('selected_domain', null);
          this.domain = this.selectedDomain && this.selectedDomain.domain
          if(!this.selectedDomain ) {
            this.selectedDomain = this.userDetails.domains[0].domain;
            UTILITY.setItemLocalStorage('selected_domain',JSON.stringify(this.selectedDomain))
          }
          this.checkOfficeTokenValidity()
          this.checkExchangeTokenValidity()
          this.domains = [];
          _.map(this.userDetails.domains,(domain) => {
            this.domains.push(domain.domain);
            if(this.selectedDomain._id == domain.domain._id) {
              this.domainSelected = domain.domain;     
            }
          })
         this.showDomainSelected = this.domainSelected.domain;
         if(this.$router.currentRoute.path == "/" || this.$router.currentRoute.path == "/reported_mails") {
            this.actionName = {
              'lable_name' : "Action Required",
              'key'        : "null",
              'count_key'  : "action_required",
              'icon'       : "fas fa-clock",
              'display'    : false
            };
         } else {
            this.actionName = '';
         }
       } else {
         this.$router.push({ name: 'auth.login' }).catch((e)=>{})
       }
      //  this.getCompanyLogo()
       
     
    },
    mounted(){
      this.checkForLogout();
      let mode = localStorage.getItem('displaymode',mode);      
      if (mode == 1 ){
        $('body').addClass('dark_mode');
      }
      if (mode == 0 ) {
        $('body').removeClass('dark_mode');
      }
    },
    beforeDestroy(){
      bus.$off('changeActionName', this._onChangeActionName)
      bus.$off('changeActionNumber', this._onChangeActionNumber)
      bus.$off('searchMailProgress', this._onSearchMailProgress)
      bus.$off('reloadTokenValidity', this._onReloadTokenValidity)
      bus.$off('mimecastMessage', this._onMimecastMessage)
      clearInterval(this._logoutTimer)
    },
    watch: {
      isLogged(value) { // isLogged changes when the token changes
        if (value === false) {
          this.$router.push({ name: 'auth.login' }).catch((e)=>{})
        } 
      },
      $route (to, from){
        if(this.$router.currentRoute.path == "/" || this.$router.currentRoute.path == "/reported_mails") {
          this.actionName = {
            'lable_name' : "Action Required",
            'key'        : "null",
            'count_key'  : "action_required",
            'icon'       : "fas fa-clock",
            'display'    : false
          };
        } else {
          this.actionName = '';
        }
      }
    },
    methods: {
      checkForLogout() {
        let that = this;
        this._logoutTimer = setInterval(() => {
          if (!localStorage.getItem('user')) {
            clearInterval(this._logoutTimer)
            this.removeItemFromLocalStorage()
          }
        }, 30000);
      },
      checkOfficeTokenValidity(domain) {
          console.log("🚀 ~ file: navbar.vue ~ line 212 ~ checkOfficeTokenValidity ~ this.domain_provider", this.domain_provider)

        if(this.domain_provider ==2 || this.domain_provider ==5){
          this.officeTokenLoader = true
          let url = 'office/token/checkstatus'
          if(!domain){
            domain = this.selectedDomain.domain
          }
          http.post(url,{domain}).then((response)=> {
            this.officeTokenLoader = false
            if (response.data && response.data.success ){ 
                  this.officeTokenValidity = response.data.data
                  UTILITY.setItemLocalStorage('officeTokenValidity', btoa(this.officeTokenValidity))
                  bus.$emit('setOfficeTokenValidity')

            }
          }).catch((e)=>{
            this.officeTokenLoader = false
          })
        }
      },
      checkExchangeTokenValidity(domain) {
        if(this.domain_provider ==4 || this.domain_provider ==5){
          this.exchangeEwsTokenLoader = true
          let url = 'exchange/domain/checkewsstatus'
          if(!domain){
            domain = this.selectedDomain.domain
          }
          http.post(url,{domain}).then((response)=> {
            this.exchangeEwsTokenLoader = false
            if (response.data && response.data.success ){ 
              this.exchangeEwsValidity = response.data.ewsStatus
              UTILITY.setItemLocalStorage('exchangeEwsValidity', btoa(this.exchangeEwsValidity))
              bus.$emit('setexchangeEwsValidity')
            }
          }).catch((e)=>{
            this.exchangeEwsTokenLoader = false
          })
        }
      },
      getUserRole(){
        if(this.userDetails.domains && this.userDetails.domains.length && this.userDetails.domains[0].profile){
          http.post('common/rules/fetchuserrole',{role:this.userDetails.domains[0].profile}).then((response)=>{
            if (response.data && response.data.profile ){
              this.userAssignedRole = response.data.profile
            }
          }).catch((e)=>{})
        }
      },
      checkProgress(obj){
        let code = obj.code ; 
        let url = obj.url ; 
        let content = obj.content ;
        let message_to_show ;  
          let data = {'code':code};
            http.post(url,data).then((response)=> {
                let doneRecord = 0
                let totalRecord = 0
                if(this.domain_provider == 5){
                    doneRecord = ((parseInt(response.data.office.success) || 0)+(parseInt(response.data.exchange.success) || 0)+(parseInt(response.data.office.failure) || 0)+(parseInt(response.data.exchange.failure) || 0));
                    totalRecord = ((parseInt(response.data.office.total) || 0)+(parseInt(response.data.exchange.total) || 0));
                }else{
                    doneRecord = (parseInt(response.data.success)+parseInt(response.data.failure));
                    totalRecord = parseInt(response.data.total);
                }
                if (doneRecord == totalRecord){
                  if (obj && obj.done) {
                     return ; 
                  } else {
                    // We need to show the toast notification 
                    obj.done = true ; 
                    if(content == 'label') {
                      message_to_show = `mails have been labeled successfully`;
                    } else if(content == 'quarantine') {
                      message_to_show = `mails have been quarantined successfully`;
                    } else if(content == 'trash') {
                      message_to_show = `mails have been trashed successfully`;
                    } else if(content == 'delete') {
                      message_to_show = `mails have been deleted successfully`;
                    } else if(content == 'ticket') {
                      message_to_show = `Tickets have been generated successfully`;
                    }
                    message_to_show = message_to_show 
                    this.$toasted.show(message_to_show,{
                      duration:3000,
                      // containerClass:['prompt_message_text','bg-success'],
                      theme:"toasted-primary",
                      position: "top-right", 
                    });
                  }
                } else {
                  setTimeout(function() {
                  this.checkProgress(obj)  
                  }.bind(this), 7000);
                }
            }).catch((e)=>{})
      },
      /**
      * Makes logout() action available withint this component
      * See /src/app/auth/vuex/actions.js
      */
     
      toggleMode(){
        let mode = 0 ; 
        $('body').toggleClass('dark_mode')
        
        if ($('body').attr('class').split(' ').indexOf('dark_mode') > -1){
          mode = 1 ; 
        }
        else{
          mode = 0 ; 
        }
        http.get('common/rules/displaysettings?email='+ this.currentUser.primaryEmail +'&mode='+mode.toString()).catch((e)=>{});
        UTILITY.setItemLocalStorage('displaymode', mode)
      },
      updateDomain() {
        _.map(this.userDetails.domains,(domain) => {
          if(this.showDomainSelected == domain.domain.domain) {
            this.domainSelected = domain.domain;     
          }
        })
        UTILITY.setItemLocalStorage('officeTokenValidity', '')
        UTILITY.setItemLocalStorage('exchangeEwsValidity', '')
        UTILITY.setItemLocalStorage('selected_domain',JSON.stringify(this.domainSelected))
        location.reload();
      },
      logOut() {
        http.post('auth/logout', []).then(response => {
          // console.log(response)
          this.removeItemFromLocalStorage()
        }).catch(err =>{
          //
        })
      },
      capitalize(str) {
        let splitStr = str.toLowerCase().split(' ').map(i=>i.charAt(0).toUpperCase() + i.substring(1));
        return splitStr.join(' '); 
      },

      checkUserPermission(name){
				let status = false;
				let user = JSON.parse(localStorage.getItem('user')|| null);
				var index = ((user && user.permissions) || []).findIndex((obj => obj == name));
				if(index!=-1){
					status = true;
				}
				return status;
	  	},
      getCompanyLogo(){
            this.successMessage = '';
            this.errorMessage = '';
            http.get('common/rules/getcompanylogo?domain='+this.domain).then(response=>{
                if(response.data && response.data.status){
                    const imageUrl = response.data.logo
                    console.log("🚀 ~ file: navbar.vue:364 ~ http.get ~ imageUrl:", imageUrl)
                    // Split the URL by "/" to get an array of segments
                    const urlSegments = imageUrl.split("/");
                    const imageName = urlSegments[urlSegments.length - 1];
                    this.companylogo = baseServerUrl + '/images/'+ imageName

                }
            }).catch((e)=>{})
        }
    },
  }
</script>

<style>
.toasting {
  color: rgb(250, 104, 104) !important;
  background-color: rgb(240, 194, 194) !important;  
  height: 60px !important;
}
</style>





// WEBPACK FOOTER //
// src/components/root/navbar.vue